/**
 * BrewNectar Product FAQ — accessible accordion + staggered fade-up
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFadeUp(section) {
    if (section.classList.contains('bn-pfaq--static')) {
      section.querySelectorAll('.bn-pfaq__animate').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var animated = section.querySelectorAll('.bn-pfaq__animate');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = section.getAttribute('data-bn-pfaq-observer-margin') || '-60px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function setItemOpen(item, open) {
    var trigger = item.querySelector('[data-bn-pfaq-trigger]');
    var panel = item.querySelector('[data-bn-pfaq-panel]');
    if (!trigger || !panel) return;

    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function initAccordion(section) {
    var allowMultiple = section.getAttribute('data-bn-pfaq-allow-multiple') === 'true';
    var items = section.querySelectorAll('[data-bn-pfaq-item]');
    var triggers = section.querySelectorAll('[data-bn-pfaq-trigger]');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-bn-pfaq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (!allowMultiple) {
          items.forEach(function (other) {
            if (other !== item) setItemOpen(other, false);
          });
        }

        setItemOpen(item, !isOpen);
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        }
      });
    });

    section.addEventListener('keydown', function (e) {
      var triggerList = Array.prototype.slice.call(triggers);
      var index = triggerList.indexOf(document.activeElement);
      if (index === -1) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = triggerList[Math.min(index + 1, triggerList.length - 1)];
        if (next) next.focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = triggerList[Math.max(index - 1, 0)];
        if (prev) prev.focus();
      } else if (e.key === 'Home') {
        e.preventDefault();
        if (triggerList[0]) triggerList[0].focus();
      } else if (e.key === 'End') {
        e.preventDefault();
        if (triggerList[triggerList.length - 1]) triggerList[triggerList.length - 1].focus();
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.bnPfaqInit === 'true') return;
    section.dataset.bnPfaqInit = 'true';

    initFadeUp(section);
    initAccordion(section);
  }

  function initAll() {
    document.querySelectorAll('.bn-pfaq').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bn-pfaq');
    if (section) initSection(section);
  });
})();
